var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card p-3 dashboard d-flex flex-column",staticStyle:{"height":"calc(100dvh - 6rem)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }